<template>
    <div :bordered="false">
        <div class="table-page-search-wrapper">
            <!-- ========== 统计概览卡片 ========== -->
            <a-row :gutter="16" class="statistics-row">
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="stat-card stat-card-cyan">
                        <div class="stat-info">
                            <div class="stat-title">{{ $t(I18N_KEY.COLLECTION + 'monitoringTotalMember') }}</div>
                            <div class="stat-value">
                                {{ statistics.monitoringNumbers }}
                                <span class="stat-unit">{{ $t(I18N_KEY.COLLECTION + 'people') }}</span>
                            </div>
                            <div class="stat-sub">{{ $t(I18N_KEY.COLLECTION + 'onlineRate') }} {{ statistics.onlineRate }}</div>
                        </div>
                        <div class="stat-icon">
                            <a-icon type="team" />
                        </div>
                    </div>
                </a-col>
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="stat-card stat-card-green">
                        <div class="stat-info">
                            <div class="stat-title">{{ $t(I18N_KEY.COLLECTION + 'todayCallDuration') }}</div>
                            <div class="stat-value">
                                {{ statistics.callDuration }}
                                <span class="stat-unit">Mins</span>
                            </div>
                            <div class="stat-sub"></div>
                        </div>
                        <div class="stat-icon">
                            <a-icon type="phone" />
                        </div>
                    </div>
                </a-col>
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="stat-card stat-card-yellow">
                        <div class="stat-info">
                            <div class="stat-title">{{ $t(I18N_KEY.COLLECTION + 'positionOffsetWarning') }}</div>
                            <div class="stat-value">
                                {{ statistics.offsetNumbers }}
                                <span class="stat-unit">{{ $t(I18N_KEY.COLLECTION + 'anomaly') }}</span>
                            </div>
                            <div class="stat-sub"></div>
                        </div>
                        <div class="stat-icon">
                            <a-icon type="warning" />
                        </div>
                    </div>
                </a-col>
                <a-col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
                    <div class="stat-card stat-card-red">
                        <div class="stat-info">
                            <div class="stat-title">{{ $t(I18N_KEY.COLLECTION + 'currentLockUpPeriodTerminal') }}</div>
                            <div class="stat-value">
                                {{ statistics.lockedNumbers }}
                                <span class="stat-unit">{{ $t(I18N_KEY.COLLECTION + 'device') }}</span>
                            </div>
                            <div class="stat-sub"></div>
                        </div>
                        <div class="stat-icon">
                            <a-icon type="lock" />
                        </div>
                    </div>
                </a-col>
            </a-row>

            <!-- ========== 排名概览卡片（带皇冠图标） ========== -->
            <a-row :gutter="16" class="rank-row">
                <!-- 催收排名 -->
                <a-col :xl="8" :lg="8" :md="24" :sm="24" :xs="24">
                    <div class="rank-card">
                        <div class="rank-header rank-header-cyan">
                            <span class="rank-title">{{ $t(I18N_KEY.COLLECTION + 'collectionRank') }}</span>
                            <a class="rank-detail-link" @click="openRankDetail('colRateRank')">{{ $t(I18N_KEY.COLLECTION + 'detail') }}</a>
                        </div>
                        <div class="rank-list">
                            <div v-if="!rankData.colRateRank || rankData.colRateRank.length === 0" class="rank-empty">
                                {{ $t(I18N_KEY.COLLECTION + 'noData') }}
                            </div>
                            <div v-for="(item, index) in rankData.colRateRank" :key="'rate-' + index" class="rank-item">
                                <div class="rank-badge">
                                    <span class="rank-index" :class="{'rank-top3': index < 3}">{{ index + 1 }}</span>
                                    <a-icon v-if="index === 0" type="crown" class="rank-crown rank-crown-gold" />
                                    <a-icon v-else-if="index === 1" type="crown" class="rank-crown rank-crown-silver" />
                                    <a-icon v-else-if="index === 2" type="crown" class="rank-crown rank-crown-bronze" />
                                </div>
                                <span class="rank-name">{{ item.groupName }} - {{ item.mobile }}</span>
                                <span class="rank-value">{{ item.succRate }}%</span>
                            </div>
                        </div>
                    </div>
                </a-col>
                <!-- 通话排名 -->
                <a-col :xl="8" :lg="8" :md="24" :sm="24" :xs="24">
                    <div class="rank-card">
                        <div class="rank-header rank-header-green">
                            <span class="rank-title">{{ $t(I18N_KEY.COLLECTION + 'callRank') }}</span>
                            <a class="rank-detail-link" @click="openRankDetail('colCallRank')">{{ $t(I18N_KEY.COLLECTION + 'detail') }}</a>
                        </div>
                        <div class="rank-list">
                            <div v-if="!rankData.colCallRank || rankData.colCallRank.length === 0" class="rank-empty">
                                {{ $t(I18N_KEY.COLLECTION + 'noData') }}
                            </div>
                            <div v-for="(item, index) in rankData.colCallRank" :key="'call-' + index" class="rank-item">
                                <div class="rank-badge">
                                    <span class="rank-index" :class="{'rank-top3': index < 3}">{{ index + 1 }}</span>
                                    <a-icon v-if="index === 0" type="crown" class="rank-crown rank-crown-gold" />
                                    <a-icon v-else-if="index === 1" type="crown" class="rank-crown rank-crown-silver" />
                                    <a-icon v-else-if="index === 2" type="crown" class="rank-crown rank-crown-bronze" />
                                </div>
                                <span class="rank-name">{{ item.groupName }} - {{ item.mobile }}</span>
                                <span class="rank-value">{{ item.callDurationMin }}Mins</span>
                            </div>
                        </div>
                    </div>
                </a-col>
                <!-- 活跃排名 -->
                <a-col :xl="8" :lg="8" :md="24" :sm="24" :xs="24">
                    <div class="rank-card">
                        <div class="rank-header rank-header-yellow">
                            <span class="rank-title">{{ $t(I18N_KEY.COLLECTION + 'activityRank') }}</span>
                            <a class="rank-detail-link" @click="openRankDetail('colActivityRank')">{{ $t(I18N_KEY.COLLECTION + 'detail') }}</a>
                        </div>
                        <div class="rank-list">
                            <div v-if="!rankData.colActivityRank || rankData.colActivityRank.length === 0" class="rank-empty">
                                {{ $t(I18N_KEY.COLLECTION + 'noData') }}
                            </div>
                            <div v-for="(item, index) in rankData.colActivityRank" :key="'act-' + index" class="rank-item">
                                <div class="rank-badge">
                                    <span class="rank-index" :class="{'rank-top3': index < 3}">{{ index + 1 }}</span>
                                    <a-icon v-if="index === 0" type="crown" class="rank-crown rank-crown-gold" />
                                    <a-icon v-else-if="index === 1" type="crown" class="rank-crown rank-crown-silver" />
                                    <a-icon v-else-if="index === 2" type="crown" class="rank-crown rank-crown-bronze" />
                                </div>
                                <span class="rank-name">{{ item.groupName }} - {{ item.mobile }}</span>
                                <span class="rank-value">{{ item.callTimes }}{{ $t(I18N_KEY.COLLECTION + 'time') }}</span>
                            </div>
                        </div>
                    </div>
                </a-col>
            </a-row>

          <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                   <a-col :md='10' :sm='10'>
                        <a-form-item :label="$t(I18N_KEY.COLLECTION + 'queryTime')">
                            <a-date-picker v-model='queryParam.queryDate' format='YYYY-MM-DD' value-format="YYYY-MM-DD" style='width: 100%;' />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="8">
                        <a-form-item :label="$t(I18N_KEY.COLLECTION + 'queryKeyword')">
                            <a-input :placeholder="$t(I18N_KEY.COLLECTION + 'keywordInput')" v-model="queryParam.keyword" />
                        </a-form-item>
                    </a-col>
                    <a-col :md='6' :sm='8'>
                        <a-form-item :label="$t(I18N_KEY.COLLECTION + 'grouping')">
                            <a-select v-model='queryParam.groupId' allowClear>
                                <a-select-option v-for='item in groupList' :key='item.id'>
                                    {{ item.groupName }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>

                    <a-col :md='6' :sm='8'>
                        <a-form-item :label="$t(I18N_KEY.COLLECTION + 'normalConfig')">
                            <a-select default-value='' style='width: 190px' v-model='queryParam.normalConfigId'
                                allowClear>
                                <a-select-option v-for='item in normalConfigList' :key='item.id'>
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="3" :sm="4">
                        <a-button type="primary" @click="searchQuery">{{ $t('search') }}</a-button>
                    </a-col>
                    <a-col :md="4" :sm="4">
                        <a-button @click="searchReset" icon="reload">{{ $t('reset') }}</a-button>
                    </a-col>
                    <a-col :md="4" :sm="4">
                        <a-button type="primary" icon="setting" @click="openConfigModal">
                            {{ $t(I18N_KEY.COLLECTION + 'configButton') }}
                        </a-button>
                    </a-col>
                </a-row>
            </a-form>

            <!-- 数据表格 -->
            <a-table ref="table" size="middle" :columns="columns" :dataSource="dataSource" :pagination="false"
                :loading="loading" bordered @change="handleTableChange" rowKey="id" class="dark-table">
                <!-- 锁定开关列 -->
                <template slot="lockFlag" slot-scope="text, record">
                    <a-switch 
                        size="small"
                        :checked="String(text) === '1' || text === 1"
                        :loading="record.lockLoading"
                        @change="(checked) => handleLockChange(checked, record)" 
                    />
                </template>
                <!-- 活跃度热力图列 -->
                <template slot="activityHeatmap" slot-scope="text, record">
                    <div class="heatmap-row">
                        <div
                            v-for="slot in 144"
                            :key="slot"
                            class="heatmap-cell"
                            :style="{ backgroundColor: getHeatmapColor(slot, record) }"
                            :title="getHeatmapTitle(slot, record)"
                        ></div>
                    </div>
                </template>
            </a-table>
            <div style='margin-top: 15px; text-align: right;' >
                <v-pagination v-if='total' :page-num='form.pageNum' :page-size='form.pageSize' :total='total'
                    @change='handleTableChange' />
            </div>
        </div>

        <!-- ========== 配置列表弹窗 ========== -->
        <a-modal
            v-model="configVisible"
            :title="$t(I18N_KEY.COLLECTION + 'configManage')"
            :footer="null"
            :width="900"
            :destroyOnClose="false"
            @cancel="closeConfigModal"
        >
            <div class="config-modal-wrapper">
                <!-- 搜索栏 -->
                <a-form layout="inline" style="margin-bottom: 16px;">
                    <a-form-item :label="$t(I18N_KEY.COLLECTION + 'configKey')">
                        <a-input
                            v-model="configQueryParam.configKeyWord"
                            :placeholder="$t(I18N_KEY.COLLECTION + 'configKeyInput')"
                            allowClear
                            style="width: 220px;"
                        />
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" icon="search" @click="handleConfigSearch">{{ $t('search') }}</a-button>
                        <a-button style="margin-left: 8px;" icon="reload" @click="handleConfigReset">{{ $t('reset') }}</a-button>
                    </a-form-item>
                    <a-form-item style="float: right;">
                        <a-button type="primary" icon="plus" @click="openConfigForm('add')">{{ $t('add') }}</a-button>
                    </a-form-item>
                </a-form>

                <!-- 配置表格 -->
                <a-table
                    size="middle"
                    :columns="configColumns"
                    :dataSource="configDataSource"
                    :pagination="false"
                    :loading="configLoading"
                    bordered
                    rowKey="id"
                >
                    <template v-slot:action="record">
                        <a @click="openConfigForm('edit', record)">{{ $t('edit') }}</a>
                    </template>
                </a-table>

                <!-- 分页 -->
                <div style="margin-top: 15px; text-align: right;">
                    <v-pagination
                        v-if="configTotal"
                        :page-num="configForm.pageNum"
                        :page-size="configForm.pageSize"
                        :total="configTotal"
                        @change="handleConfigTableChange"
                    />
                </div>
            </div>
        </a-modal>

        <!-- ========== 新增/编辑配置弹窗 ========== -->
        <a-modal
            v-model="configFormVisible"
            :title="configFormType === 'add' ? $t(I18N_KEY.COLLECTION + 'addConfig') : $t(I18N_KEY.COLLECTION + 'editConfig')"
            :width="520"
            :confirmLoading="configSaveLoading"
            :maskClosable="false"
            @ok="handleConfigSave"
            @cancel="closeConfigForm"
        >
            <a-form :form="configFormObj" layout="vertical">
                <a-form-item :label="$t(I18N_KEY.COLLECTION + 'configKey')" required>
                    <a-input
                        v-model="configFormData.configKey"
                        :placeholder="$t(I18N_KEY.COLLECTION + 'configKeyInput')"
                        :disabled="configFormType === 'edit'"
                        :maxLength="100"
                    />
                </a-form-item>
                <a-form-item :label="$t(I18N_KEY.COLLECTION + 'configvalue')" required>
                    <a-input
                        v-model="configFormData.configValue"
                        :placeholder="$t(I18N_KEY.COLLECTION + 'configValueInput')"
                        :maxLength="500"
                    />
                </a-form-item>
                <a-form-item :label="$t(I18N_KEY.COLLECTION + 'configRemark')">
                    <a-textarea
                        v-model="configFormData.configRemark"
                        :placeholder="$t(I18N_KEY.COLLECTION + 'configRemarkInput')"
                        :rows="3"
                        :maxLength="500"
                    />
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- ========== 新增：排名详情弹窗 ========== -->
        <a-modal
            v-model="rankDetailVisible"
            :title="rankDetailTitle"
            :footer="null"
            :width="800"
            @cancel="closeRankDetail"
        >
            <a-table
                size="middle"
                :columns="rankDetailColumns"
                :dataSource="rankDetailData"
                :pagination="rankDetailPagination"
                bordered
                :rowKey="(record, index) => index"
                class="dark-table"
            />
        </a-modal>
    </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getHeaders } from '@/utils/request'
import { getSysGroup } from '@/webpublicapi/platformCollection'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { queryCollectionSurveillanceInfo, querySurveillanceConfig, saveSurveillanceConfig, lockAccount, queryColStatistics, queryColRelatedRank } from '@/webpublicapi/collection'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import vModal from '../modules/Modal'
import moment from 'moment'

const I18N_KEY = {
    COLLECTION: 'collection.',
}

export default {
    name: 'PayrollBatchList',
    components: {
        Dict,
        DictSelect,
        vModal
    },
    data() {
        return {
            I18N_KEY,
            isButtonDisabled: false,
            visible: false,
            selectedRowKeys: [],
            loading: false,
            total: 0,
            isFinanceRole: false,
            isHrRole: false,
            id: null,
            batchNo: null,
            fileName: null,
            createTime: null,
            totalCount: null,
            totalAmount: null,
            effectiveCount: null,
            effectiveAmount: null,
            rejectCount: null,
            rejectReason: null,
            status: null,
            groupList: [],
            normalConfigList: [],
            dataSource: [],
            form: {
                pageNum: 1,
                pageSize: 10,
            },
            queryParam: {
                keyword: null,
                date: [],
                queryDate: null,
                type: null,
                status: null,
                groupId: undefined,
                normalConfigId: undefined,
            },
            uploadDataParam: {},

            // ===== 统计概览数据 =====
            statistics: {
                monitoringNumbers: 0,
                onlineRate: '0',
                callDuration: 0,
                offsetNumbers: 0,
                lockedNumbers: 0
            },

            // ===== 排名数据 =====
            rankData: {
                colRateRank: [],
                colCallRank: [],
                colActivityRank: []
            },

            // ===== 新增：排名全量数据与详情弹窗 =====
            rankAllData: {
                colRateRank: [],
                colCallRank: [],
                colActivityRank: []
            },
            rankDetailVisible: false,
            rankDetailType: '',
            rankDetailData: [],
            rankDetailColumns: [],
            rankDetailPagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },

            // ===== 热力图染色阈值（从接口解析） =====
            heatmapThresholds: {
                low: 1,
                middleLow: 2,
                middle: 3,
                middleHigh: 4,
                high: 5
            },

            // ===== 配置管理相关数据 =====
            configVisible: false,
            configLoading: false,
            configSaveLoading: false,
            configTotal: 0,
            configDataSource: [],
            configQueryParam: {
                configKeyWord: null
            },
            configForm: {
                pageNum: 1,
                pageSize: 10,
            },
            // 新增/编辑弹窗
            configFormVisible: false,
            configFormType: 'add', // 'add' | 'edit'
            configFormData: {
                id: null,
                configKey: '',
                configValue: '',
                configRemark: ''
            },
            configFormObj: null,
        }
    },
    computed: {
        rankDetailTitle() {
            const titleMap = {
                colRateRank: this.$t(I18N_KEY.COLLECTION + 'collectionDetail'),
                colCallRank: this.$t(I18N_KEY.COLLECTION + 'callRankDetail'),
                colActivityRank: this.$t(I18N_KEY.COLLECTION + 'activityRankDetail')
            };
            return titleMap[this.rankDetailType] || this.$t(I18N_KEY.COLLECTION + 'defaultRankDetail');
        },
        columns() {
            const h = this.$createElement;
            return [
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'groupName'),
                    align: 'center',
                    dataIndex: 'groupName',
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionLevel'),
                    align: 'center',
                    dataIndex: 'collectionLevel',
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginName'),
                    align: 'center',
                    dataIndex: 'collectionLoginName',
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'),
                    align: 'center',
                    dataIndex: 'collectionLoginNo',
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'locationStatus'),
                    align: 'center',
                    dataIndex: 'locationStatusName',
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'clockInStatus'),
                    align: 'center',
                    dataIndex: 'clockInStatusName',
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'callStatus'),
                    align: 'center',
                    dataIndex: 'callStatusName',
                    scopedSlots: { customRender: 'status' }
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionRecordCount'),
                    align: 'center',
                    dataIndex: 'collectionRecordCount',
                },
                // {
                //     title: this.$t(I18N_KEY.COLLECTION + 'contactRate'),
                //     align: 'center',
                //     dataIndex: 'contactRate',
                // },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'collectionRate'),
                    align: 'center',
                    dataIndex: 'collectionRate',
                },
                // ===== 修改点：活跃度列 (直接使用h函数渲染Tooltip) =====
                {
                    title: () => {
                        return h('span', [
                            this.$t(I18N_KEY.COLLECTION + 'collectionActivity'),
                            h('a-tooltip', {
                                props: { placement: 'top' },
                                scopedSlots: {
                                    title: () => h('div', this.$t(I18N_KEY.COLLECTION + 'activityMsg'))
                                }
                            }, [
                                h('a-icon', {
                                    props: { type: 'question-circle' },
                                    style: { marginLeft: '6px', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }
                                })
                            ])
                        ]);
                    },
                    align: 'center',
                    dataIndex: 'collectionActivity',
                    scopedSlots: { customRender: 'activityHeatmap' },
                    width: 620
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'lockFlag'),
                    align: 'center',
                    dataIndex: 'delFlag',
                    scopedSlots: { customRender: 'lockFlag' }
                }
            ]
        },

        configColumns() {
            return [
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'configKey'),
                    align: 'center',
                    dataIndex: 'configKey',
                    width: 200,
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'configvalue'),
                    align: 'center',
                    dataIndex: 'configValue',
                    width: 250,
                    ellipsis: true,
                },
                {
                    title: this.$t(I18N_KEY.COLLECTION + 'configRemark'),
                    align: 'center',
                    dataIndex: 'configRemark',
                    ellipsis: true,
                },
                {
                    title: this.$t('action'),
                    align: 'center',
                    width: 100,
                    scopedSlots: { customRender: 'action' }
                }
            ]
        }
    },
    created() {
        getSysGroup().then(res => {
            this.groupList = res.data || []
        });
        getAllNormalConfig().then(res => {
            this.normalConfigList.push({
                'name': 'ALL',
                'id': '',
                'value': ''
            });
      res.data.forEach(item => {
        this.normalConfigList.push(item)
      })
    })
        this.loadData();
    },
    methods: {
        getHeaders() {
            return getHeaders()
        },

        handleModalClose() {
            this.visible = false;
            this.form.pageNum = 1
            this.loadData();
        },

        searchQuery() {
            this.form.pageNum = 1
            this.loadData()
        },

        loadData() {
            this.loading = true
            const params = this.getQueryParams()

            queryCollectionSurveillanceInfo(params)
                .then((res) => {
                    if (res.code === 1000) {
                        const data = res.data || {}
                        this.total = data.total || 0
                        console.log("页面数量", this.total);
                        
                        const list = Array.isArray(data.list) ? data.list : []
                        this.dataSource = list.map(item => ({
                            ...item,
                            lockLoading: false
                        }))
                        
                        // 提取热力图染色阈值（兼容 data 根级别或单条记录级别）
                        if (res.data) {
                            this.heatmapThresholds = {
                                low: this.parseThreshold(res.data.heatmapLowTotal, 1),
                                middleLow: this.parseThreshold(res.data.heatmapMiddleLowTotal, 2),
                                middle: this.parseThreshold(res.data.heatmapMiddleTotal, 3),
                                middleHigh: this.parseThreshold(res.data.heatmapMiddleHighTotal, 4),
                                high: this.parseThreshold(res.data.heatmapHighTotal, 5)
                            }
                        }
                    } else {
                        this.$message.error(res.msg)
                        this.dataSource = []
                    }
                    this.loading = false
                })
                .catch((e) => {
                    this.loading = false
                    this.$message.error(e.message)
                })
                this.loadStatistics();
                this.loadRankData();
        },

        // 解析阈值，兼容字符串/数字，兜底默认值
        parseThreshold(val, defaultVal) {
            if (val === undefined || val === null || val === '') return defaultVal
            const parsed = parseInt(val)
            return isNaN(parsed) ? defaultVal : parsed
        },

        // 获取指定 slot 的通话总数
        getCallTotal(slot, record) {
            if (!record.heatmapList || !Array.isArray(record.heatmapList)) {
                return 0
            }
            const item = record.heatmapList.find(h => parseInt(h.slotNo) === slot)
            return item ? parseInt(item.callTotal) : 0
        },

        // 获取热力图 tooltip 标题
        getHeatmapTitle(slot, record) {
            const callTotal = this.getCallTotal(slot, record)
            const hour = Math.floor((slot - 1) / 6)
            const minute = ((slot - 1) % 6) * 10
            const timeStr = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
            return `${timeStr}` + this.$t(I18N_KEY.COLLECTION + 'callTimes') + `:` + `${callTotal}`
        },

        // 获取热力图单元格颜色
        getHeatmapColor(slot, record) {
            const callTotal = this.getCallTotal(slot, record)
            if (callTotal === 0) {
                return '#2a2f3d' // 无数据时显示深灰色底，与其他卡片协调
            }

            // 优先取单条记录的阈值，取不到再用接口返回的全局阈值
            const low = this.parseThreshold(record.heatmapLowTotal, this.heatmapThresholds.low)
            const middleLow = this.parseThreshold(record.heatmapMiddleLowTotal, this.heatmapThresholds.middleLow)
            const middle = this.parseThreshold(record.heatmapMiddleTotal, this.heatmapThresholds.middle)
            const middleHigh = this.parseThreshold(record.heatmapMiddleHighTotal, this.heatmapThresholds.middleHigh)
            const high = this.parseThreshold(record.heatmapHighTotal, this.heatmapThresholds.high)

            if (callTotal <= low) {
                return '#90EE90' // 浅绿色
            } else if (callTotal <= middleLow) {
                return '#52c41a' // 绿色
            } else if (callTotal <= middle) {
                return '#fadb14' // 黄色
            } else if (callTotal <= middleHigh) {
                return '#fa8c16' // 橙色
            } else if (callTotal <= high) {
                return '#f5222d' // 红色
            } else {
                return '#f5222d' // 超过最高阈值也显示红色
            }
        },

        getQueryParams() {
            const data = {
                ...this.queryParam,
                pageNum: this.form.pageNum,
                pageSize: this.form.pageSize
            }
            return filterObj(data)
        },

        transformTime(time) {
            if (!moment.isMoment(time)) {
                return '';
            }
            return time.format('YYYY-MM-DD')
        },

        handleTableChange(pageNum, pageSize) {
            this.form.pageNum = pageNum
            this.form.pageSize = pageSize
            this.loadData()
        },

        searchReset() {
            this.queryParam = {
                keyword: null,
                date: [],
                type: null,
                status: null,
                groupId: null,
                normalConfigId: null,
                queryDate: null
            }
            this.form.pageNum = 1
            this.loadData()
        },

        handleChangeUpload(info) {
            if (info.file.status === 'done') {
                if (info.file.response?.code === 1000) {
                    this.$message.success(`${info.file.name} 上传成功`)
                    this.loadData()
                } else {
                    this.$message.error(info.file.response?.msg || '上传失败')
                }
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} 上传失败`)
            }
        },
        changeModal(visible) {
            this.visible = visible;
            if (!visible) {
                this.loadData();
            }
        },
        handleDetail(row) {
            this.id = row.id;
            this.batchNo = row.batchNo;
            this.fileName = row.fileName;
            this.createTime = row.createTime;
            this.totalCount = row.totalCount;
            this.totalAmount = row.totalAmount;
            this.effectiveCount = row.effectiveCount;
            this.effectiveAmount = row.effectiveAmount;
            this.rejectCount = row.rejectCount;
            this.rejectReason = row.rejectReason;
            this.status = row.status;
            this.changeModal(true);
        },

        // ==================== 统计概览方法 ====================

        loadStatistics() {
            const params = this.getQueryParams()
            queryColStatistics(params)
                .then((res) => {
                    if (res.code === 1000 && res.data) {
                        const d = res.data;
                        this.statistics = {
                            monitoringNumbers: d.monitoringNumbers || 0,
                            onlineRate: d.onlineRate !== undefined && d.onlineRate !== null ? d.onlineRate : '0',
                            callDuration: d.callDuration || 0,
                            offsetNumbers: d.offsetNumbers || 0,
                            lockedNumbers: d.lockedNumbers || 0
                        };
                    }
                })
                .catch(() => {
                    // 静默失败
                });
        },

        // ===== 修改点：排名数据加载（只取前3，全量存储） =====
        loadRankData() {
            const params = this.getQueryParams()
            queryColRelatedRank(params)
                .then((res) => {
                    if (res.code === 1000 && res.data) {
                        const d = res.data;
                        
                        // 保存全量数据（供详情弹窗使用）
                        this.rankAllData = {
                            colRateRank: d.colRateRank || [],
                            colCallRank: d.colCallRank || [],
                            colActivityRank: d.colActivityRank || []
                        };

                        // 截取前3条用于卡片展示
                        this.rankData = {
                            colRateRank: (d.colRateRank || []).slice(0, 3),
                            colCallRank: (d.colCallRank || []).slice(0, 3),
                            colActivityRank: (d.colActivityRank || []).slice(0, 3)
                        };
                    }
                })
                .catch(() => {
                    // 静默失败
                });
        },

        // ===== 新增：排名详情弹窗方法 =====
        openRankDetail(type) {
            this.rankDetailType = type;
            this.rankDetailData = this.rankAllData[type] || [];
            this.rankDetailPagination = {
                current: 1,
                pageSize: 10,
                total: this.rankDetailData.length
            };

            // 动态设置列
            if (type === 'colRateRank') {
                this.rankDetailColumns = [
                    { title: this.$t(I18N_KEY.COLLECTION + 'groupName'), dataIndex: 'groupName', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'), dataIndex: 'mobile', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionRate'), dataIndex: 'succRate', align: 'center', customRender: (text) => text + '%' }
                ];
            } else if (type === 'colCallRank') {
                this.rankDetailColumns = [
                    { title: this.$t(I18N_KEY.COLLECTION + 'groupName'), dataIndex: 'groupName', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'), dataIndex: 'mobile', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'todayCallDuration'), dataIndex: 'callDurationMin', align: 'center', customRender: (text) => text + ' Mins' }
                ];
            } else if (type === 'colActivityRank') {
                this.rankDetailColumns = [
                    { title: this.$t(I18N_KEY.COLLECTION + 'groupName'), dataIndex: 'groupName', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'collectionLoginNo'), dataIndex: 'mobile', align: 'center' },
                    { title: this.$t(I18N_KEY.COLLECTION + 'activityTime'), dataIndex: 'callTimes', align: 'center', customRender: (text) => text + ' 次' }
                ];
            }

            this.rankDetailVisible = true;
        },

        closeRankDetail() {
            this.rankDetailVisible = false;
            this.rankDetailType = '';
            this.rankDetailData = [];
            this.rankDetailColumns = [];
        },

        handleRankDetailTableChange(pagination) {
            this.rankDetailPagination = pagination;
        },

        handleLockChange(checked, record) {
            const userId = record.userId || record.id;
            const delFlag = checked ? '1' : '0';
            
            record.lockLoading = true;

            lockAccount({ userId, delFlag })
                .then((res) => {
                    if (res.code === 1000) {
                        this.$message.success(checked ? this.$t(I18N_KEY.COLLECTION + 'lockSuc') : this.$t(I18N_KEY.COLLECTION + 'unLockSuc'));
                        record.delFlag = delFlag;
                        this.loadStatistics();
                    } else {
                        this.$message.error(res.msg || 'action fail');
                    }
                })
                .catch((e) => {
                    this.$message.error(e.message || 'action exception');
                }).finally(() => {
                    // 请求结束，关闭加载动画
                    record.lockLoading = false;
                });
        },

        // ==================== 配置管理方法 ====================

        openConfigModal() {
            this.configVisible = true;
            this.configForm.pageNum = 1;
            this.configQueryParam.configKeyWord = null;
            this.loadConfigData();
        },

        closeConfigModal() {
            this.configVisible = false;
            this.configDataSource = [];
            this.configTotal = 0;
        },

        loadConfigData() {
            this.configLoading = true;
            const params = {
                ...this.configQueryParam,
                pageNum: this.configForm.pageNum,
                pageSize: this.configForm.pageSize
            };
            querySurveillanceConfig(filterObj(params))
                .then((res) => {
                    if (res.code === 1000) {
                        this.configTotal = res.data.total || 0;
                        this.configDataSource = res.data.list || [];
                    } else {
                        this.$message.error(res.msg || 'query config fail');
                        this.configDataSource = [];
                    }
                    this.configLoading = false;
                })
                .catch((e) => {
                    this.configLoading = false;
                    this.$message.error(e.message || 'query config exception');
                });
        },

        handleConfigSearch() {
            this.configForm.pageNum = 1;
            this.loadConfigData();
        },

        handleConfigReset() {
            this.configQueryParam.configKeyWord = null;
            this.configForm.pageNum = 1;
            this.loadConfigData();
        },

        handleConfigTableChange(pageNum, pageSize) {
            this.configForm.pageNum = pageNum;
            this.configForm.pageSize = pageSize;
            this.loadConfigData();
        },

        openConfigForm(type, record = null) {
            this.configFormType = type;
            this.configFormVisible = true;

            if (type === 'edit' && record) {
                this.configFormData = {
                    id: record.id || null,
                    configKey: record.configKey || '',
                    configValue: record.configValue || '',
                    configRemark: record.configRemark || ''
                };
            } else {
                this.configFormData = {
                    id: null,
                    configKey: '',
                    configValue: '',
                    configRemark: ''
                };
            }
        },

        closeConfigForm() {
            this.configFormVisible = false;
            setTimeout(() => {
                this.configFormData = {
                    id: null,
                    configKey: '',
                    configValue: '',
                    configRemark: ''
                };
            }, 200);
        },

        handleConfigSave() {
            const { configKey, configValue, configRemark, id } = this.configFormData;

            if (!configKey || String(configKey).trim() === '') {
                this.$message.warning(this.$t(I18N_KEY.COLLECTION + 'configKeyMsg'));
                return;
            }
            if (!configValue || String(configValue).trim() === '') {
                this.$message.warning(this.$t(I18N_KEY.COLLECTION + 'configValueMsg'));
                return;
            }

            this.configSaveLoading = true;

            const params = {
                configKey: String(configKey).trim(),
                configValue: String(configValue).trim(),
                configRemark: configRemark ? String(configRemark).trim() : ''
            };

            if (this.configFormType === 'edit' && id) {
                params.id = id;
            }

            saveSurveillanceConfig(params)
                .then((res) => {
                    this.configSaveLoading = false;
                    if (res.code === 1000) {
                        this.$message.success(this.configFormType === 'add' ? this.$t(I18N_KEY.COLLECTION + 'addSuc') : this.$t(I18N_KEY.COLLECTION + 'editSuc'));
                        this.closeConfigForm();
                        this.loadConfigData();
                    } else {
                        this.$message.error(res.msg || 'save success');
                    }
                })
                .catch((e) => {
                    this.configSaveLoading = false;
                    this.$message.error(e.message || 'save exception');
                });
        }
    },
}
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";

/deep/ .status-dropdown-fix {
    max-height: 300px !important;
    overflow-y: auto !important;
    overscroll-behavior: contain !important;
    z-index: 1050 !important;
}

/deep/ .status-dropdown-fix .ant-select-dropdown-menu {
    max-height: 300px !important;
    overflow-y: auto !important;
    overscroll-behavior: contain !important;
}

/* ========== 统计概览卡片样式 ========== */
.statistics-row {
    margin: 16px 0;

    .ant-col {
        margin-bottom: 12px;
    }
}

.stat-card {
    position: relative;
    background: #141b2d;
    border-radius: 10px;
    padding: 0 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    transition: transform 0.2s;
    height: 118px;

    &:hover {
        transform: translateY(-2px);
    }

    .stat-info {
        z-index: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;

        .stat-title {
            color: rgba(255, 255, 255, 0.5);
            font-size: 13px;
            margin-bottom: 10px;
            letter-spacing: 0.5px;
        }

        .stat-value {
            color: #fff;
            font-size: 26px;
            font-weight: 700;
            line-height: 1.2;

            .stat-unit {
                font-size: 13px;
                font-weight: 400;
                margin-left: 4px;
                opacity: 0.85;
            }
        }

        .stat-sub {
            color: rgba(255, 255, 255, 0.4);
            font-size: 12px;
            margin-top: 6px;
            min-height: 18px;
        }
    }

    .stat-icon {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        flex-shrink: 0;
    }
}

.stat-card-cyan {
    .stat-value { color: #00d9ff; }
    .stat-icon { color: #00d9ff; background: rgba(0, 217, 255, 0.12); }
}
.stat-card-green {
    .stat-value { color: #00e676; }
    .stat-icon { color: #00e676; background: rgba(0, 230, 118, 0.12); }
}
.stat-card-yellow {
    .stat-value { color: #ffea00; }
    .stat-icon { color: #ffea00; background: rgba(255, 234, 0, 0.12); }
}
.stat-card-red {
    .stat-value { color: #ff4d4f; }
    .stat-icon { color: #ff4d4f; background: rgba(255, 77, 79, 0.12); }
}

/* ========== 排名概览卡片样式（含皇冠图标） ========== */
.rank-row {
    margin: 16px 0;

    .ant-col {
        margin-bottom: 12px;
    }
}

.rank-card {
    background: #141b2d;
    border-radius: 10px;
    padding: 16px 20px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    height: 100%;
    min-height: 280px;
}

.rank-header {
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .rank-title {
        color: #fff;
        font-size: 15px;
        font-weight: 600;
        letter-spacing: 0.5px;

        &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 14px;
            border-radius: 2px;
            margin-right: 8px;
            vertical-align: middle;
        }
    }

    /* 新增：详情链接样式 */
    .rank-detail-link {
        color: #1890ff;
        font-size: 13px;
        cursor: pointer;
        
        &:hover {
            color: #40a9ff;
        }
    }

    &.rank-header-cyan .rank-title::before {
        background: #00d9ff;
    }

    &.rank-header-green .rank-title::before {
        background: #00e676;
    }

    &.rank-header-yellow .rank-title::before {
        background: #ffea00;
    }
}

.rank-list {
    .rank-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.04);

        &:last-child {
            border-bottom: none;
        }
    }
}

/* 排名序号 + 皇冠 组合区域 */
.rank-badge {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 10px;
    min-width: 48px;

    .rank-index {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.08);
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &.rank-top3 {
            background: rgba(255, 174, 0, 0.2);
            color: #ffae00;
        }
    }

    /* 皇冠图标 */
    .rank-crown {
        font-size: 14px;
        margin-left: 4px;
        flex-shrink: 0;

        &.rank-crown-gold {
            color: #FFD700;
        }

        &.rank-crown-silver {
            color: #C0C0C0;
        }

        &.rank-crown-bronze {
            color: #CD7F32;
        }
    }
}

.rank-name {
    flex: 1;
    color: rgba(255, 255, 255, 0.75);
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 8px;
}

.rank-value {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
}

.rank-empty {
    text-align: center;
    color: rgba(255, 255, 255, 0.3);
    font-size: 13px;
    padding: 40px 0;
}

/* ========== 活跃度热力图样式 ========== */
.heatmap-row {
    display: flex;
    gap: 1px;
    height: 22px;
    align-items: center;
    width: 100%;
    flex-wrap: nowrap;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 4px;
    padding: 2px;
    overflow: hidden;
}

.heatmap-cell {
    flex: 0 0 3px;
    width: 3px;
    height: 16px;
    border-radius: 1px;
    cursor: pointer;
    transition: transform 0.2s, opacity 0.2s;

    &:hover {
        transform: scaleY(1.3);
        opacity: 0.8;
    }
}

/* ========== 深色表格主题 ========== */
.dark-table {
    /deep/ .ant-table {
        background: transparent;
        color: rgba(255, 255, 255, 0.85);
    }

    /deep/ .ant-table-thead > tr > th {
        background: #1a2236;
        color: rgba(255, 255, 255, 0.85);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        font-weight: 600;
    }

    /deep/ .ant-table-tbody > tr > td {
        background: #141b2d;
        color: rgba(255, 255, 255, 0.85);
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    }

    /deep/ .ant-table-tbody > tr:hover > td {
        background: #1a2236;
    }

    /deep/ .ant-table-bordered .ant-table-thead > tr > th,
    /deep/ .ant-table-bordered .ant-table-tbody > tr > td {
        border-right: 1px solid rgba(255, 255, 255, 0.08);
    }

    /deep/ .ant-table-bordered .ant-table-thead > tr > th:last-child,
    /deep/ .ant-table-bordered .ant-table-tbody > tr > td:last-child {
        border-right: none;
    }

    /deep/ .ant-table-placeholder {
        background: #141b2d;
        color: rgba(255, 255, 255, 0.4);
        border-top: 1px solid rgba(255, 255, 255, 0.08);
    }

    /deep/ .ant-empty-description {
        color: rgba(255, 255, 255, 0.4);
    }

    /deep/ .ant-table-tbody > tr.ant-table-row-selected td {
        background: #1a2236;
    }
}

/* ========== 深色分页器 ========== */
.dark-pagination-wrapper {
    /deep/ .ant-pagination-item {
        background: #141b2d;
        border-color: rgba(255, 255, 255, 0.15);
        a {
            color: rgba(255, 255, 255, 0.65);
        }
    }

    /deep/ .ant-pagination-item-active {
        background: #1890ff;
        border-color: #1890ff;
        a {
            color: #fff;
        }
    }

    /deep/ .ant-pagination-prev .ant-pagination-item-link,
    /deep/ .ant-pagination-next .ant-pagination-item-link {
        background: #141b2d;
        border-color: rgba(255, 255, 255, 0.15);
        color: rgba(255, 255, 255, 0.65);
    }

    /deep/ .ant-pagination-disabled .ant-pagination-item-link {
        color: rgba(255, 255, 255, 0.25);
    }

    /deep/ .ant-pagination-options-quick-jumper {
        color: rgba(255, 255, 255, 0.65);
        input {
            background: #141b2d;
            border-color: rgba(255, 255, 255, 0.15);
            color: rgba(255, 255, 255, 0.85);
        }
    }

    /deep/ .ant-pagination-total-text {
        color: rgba(255, 255, 255, 0.5);
    }
}

/* 配置弹窗内边距优化 */
.config-modal-wrapper {
    /deep/ .ant-form-inline .ant-form-item {
        margin-bottom: 12px;
    }
}
</style>